import { styled } from 'styled-components'

/**
 * The restore control, positioned at the end of the header row exactly where
 * the collapse control is in the `narrow` variant of the ActionPanel, so the
 * "same" button doesn't shift when touched.
 *
 * Rendered into `.ag-root` through a portal to inherit AG Grid CSS variables.
 * With `--ag-internal-pinned-right-sticky-offset`, it accounts for optional
 * and device-specific scrollbar width.
 *
 * Not `.ag-header`: it is inside the scroller and as wide as all columns.
 * Not `.ag-root-wrapper`: the sticky offset is published on `.ag-root`.
 */
export const Overlay = styled.div`
  align-items: center;
  background: var(--ag-header-background-color);
  border-left: var(--ag-header-row-border);
  display: flex;
  height: var(--ag-header-height);
  /* Gutter in the padding, not right: AG Grid's own spacer is opacity 0. */
  padding: 0
    calc(
      var(--ag-cell-horizontal-padding) +
        var(--ag-internal-pinned-right-sticky-offset, 0px)
    )
    0 var(--ag-cell-horizontal-padding);
  position: absolute;
  right: 0;
  top: 0;
  /* over sticky header row at z-index:2 */
  z-index: 3;
`
